export default __webpack_public_path__ + "static/media/fr.193fbc05.svg";